import cmp from './PendingBids'

export default cmp
